import { isStringNotEmpty } from './GlobalFunctions'

export const NameSpacing: (nameSpace: string, fieldName: string) => string = (
    nameSpace: Nullable<string>,
    fieldName: string
): string => (isStringNotEmpty(nameSpace) ? `${nameSpace}.${fieldName}` : fieldName)
